import { createContext, useContext, useState, useEffect, useCallback, ReactNode } from "react";
import { useLocation, useNavigate } from "react-router-dom";

interface WarningPopupContextType {
  isOpen: boolean;
  open: () => void;
  close: () => void;
}

const WarningPopupContext = createContext<WarningPopupContextType | null>(null);

export const useWarningPopup = () => {
  const ctx = useContext(WarningPopupContext);
  if (!ctx) throw new Error("useWarningPopup must be used within WarningPopupProvider");
  return ctx;
};

export const WarningPopupProvider = ({ children }: { children: ReactNode }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const [previousPath, setPreviousPath] = useState("/");

  useEffect(() => {
    if (location.pathname === "/aviso") {
      setIsOpen(true);
    }
  }, [location.pathname]);

  const open = useCallback(() => {
    setPreviousPath(location.pathname);
    setIsOpen(true);
    window.history.pushState({}, "", "/aviso");
  }, [location.pathname]);

  const close = useCallback(() => {
    setIsOpen(false);
    navigate(previousPath === "/aviso" ? "/" : previousPath, { replace: true });
  }, [navigate, previousPath]);

  return (
    <WarningPopupContext.Provider value={{ isOpen, open, close }}>
      {children}
    </WarningPopupContext.Provider>
  );
};
